import { createI18n } from 'vue-i18n'
import en_US from './en_US.json'

const language = localStorage.getItem('locale') as string

export const i18n = createI18n({
  locale: language || 'en_US',
  fallbackLocale: 'en_US',
  globalInjection: true,
  legacy: false,
  messages: {
    en_US
  }
})

